import React, { useEffect, useState } from "react";

const PhotoGalleryModal = ({ images, initialIndex = 0, onClose }) => {
  const [currentIndex, setCurrentIndex] = useState(initialIndex);

  useEffect(() => {
    const handleKeyDown = (e) => {
      if (e.key === "Escape") onClose();
      if (e.key === "ArrowLeft") handlePrevious();
      if (e.key === "ArrowRight") handleNext();
    };

    window.addEventListener("keydown", handleKeyDown);
    document.body.style.overflow = "hidden";

    return () => {
      window.removeEventListener("keydown", handleKeyDown);
      document.body.style.overflow = "unset";
    };
  });

  const handleNext = () => {
    setCurrentIndex((prev) => (prev + 1) % images.length);
  };

  const handlePrevious = () => {
    setCurrentIndex((prev) => (prev - 1 + images.length) % images.length);
  };

  return (
    <div className="photo-modal-overlay" onClick={onClose}>
      <div className="photo-modal-content" onClick={(e) => e.stopPropagation()}>
        <button className="photo-modal-close" onClick={onClose}>
          <i className="icofont-close"></i>
        </button>

        <button className="photo-modal-prev" onClick={handlePrevious}>
          <i className="icofont-thin-left"></i>
        </button>

        <img
          src={images[currentIndex]}
          alt={`${currentIndex + 1} / ${images.length}`}
          className="photo-modal-image"
        />

        <button className="photo-modal-next" onClick={handleNext}>
          <i className="icofont-thin-right"></i>
        </button>

        <div className="photo-modal-counter">
          {currentIndex + 1} / {images.length}
        </div>
      </div>
    </div>
  );
};

export default PhotoGalleryModal;
